import * as XLSX from 'xlsx';

(function() {
    var root = document.querySelector('[data-control="cashPricing"]');
    if (!root) return;

    var AU_API = (window.AUApi && window.AUApi.cashPricing) || {};
    var SITES_API = AU_API.sites;
    var COMMODITY_API = AU_API.commodity;
    var GRADES_API = AU_API.grades;
    var PRICING_API = AU_API.pricing;
    var SITE_GRADE_API = AU_API.siteGrade;
    var REGIONS_API = AU_API.regions || {};
    var REGION_NAMES = Object.keys(REGIONS_API);

    function buildUrl(template, tokens) {
        if (!template) return null;
        return Object.keys(tokens || {}).reduce(function(url, key) {
            return url.split('{' + key + '}').join(tokens[key]);
        }, template);
    }

    function q(sel) {
        return root.querySelector(sel);
    }
    function clonePrototype(region, selector) {
        var source = q('[data-region="' + region + '"]');
        if (source && selector) source = source.querySelector(selector);
        if (!source) return null;
        var clone = source.cloneNode(true);
        clone.removeAttribute('data-region');
        return clone;
    }

    var loadingEl = q('[data-region="loading"]');
    var errorEl = q('[data-region="error"]');
    var noResultsEl = q('[data-region="noResults"]');
    var regionErrorEl = q('[data-region="regionError"]');
    var regionErrorTextEl = q('[data-region="regionErrorText"]');
    var regionErrorTemplate = regionErrorTextEl
        ? regionErrorTextEl.textContent
        : '';
    var noRegionsEl = q('[data-region="noRegionsConfigured"]');
    var tableWrapper = q('[data-region="tableWrapper"]');
    var filtersRow = q('[data-region="filtersRow"]');
    var tableBody = q('[data-region="tableBody"]');
    var siteView = q('[data-region="siteView"]');
    var commodityView = q('[data-region="commodityView"]');
    var refreshSpan = q('[data-region="refreshTime"]');
    var refreshBtn = q('[data-region="refreshBtn"]');
    var exportBtn = q('[data-region="exportBtn"]');

    var siteDropdownEl = q('[data-region="siteDropdown"]');
    var siteToggle = q('[data-region="siteToggle"]');
    var siteMenuEl = q('[data-region="siteMenu"]');
    var siteSearchEl = q('[data-region="siteSearch"]');

    var commodityDropdownEl = q('[data-region="commodityDropdown"]');
    var commodityToggle = q('[data-region="commodityToggle"]');
    var commodityMenuEl = q('[data-region="commodityMenu"]');

    var commodityMenuScrollTop = 0;
    if (commodityMenuEl) {
        commodityMenuEl.addEventListener('scroll', function() {
            commodityMenuScrollTop = commodityMenuEl.scrollTop;
        });
    }

    var poolCheck = q('[data-filter="pool"]');
    var extendedCheck = q('[data-filter="extended"]');

    var groupByDropdownEl = q('[data-region="groupByDropdown"]');
    var groupByToggle = q('[data-region="groupByToggle"]');
    var groupByMenuEl = q('[data-region="groupByMenu"]');
    var groupByRadios = root.querySelectorAll('[data-group-by]');

    var allData = [];
    var allSites = [];
    var allSitesSet = null;
    var allCommodities = [];
    var allGrades = {};
    var commodityRankMap = {};
    var SITE_GRADE_BATCH = 5;
    var excludedSites = new Set();
    var excludedGrades = new Set();
    var commodityTabsWithData = new Set();
    var activeCommodity = null;
    var groupBy = 'none';
    var gradesLoaded = false;

    var firstSortHeader = root.querySelector('[data-sort]');
    var sortBy = firstSortHeader
        ? firstSortHeader.getAttribute('data-sort')
        : '';
    var sortDir = 'default';
    var currentTableRows = [];
    var commodityMenuCheckboxes = [];
    var gradeMenuCheckboxes = [];
    var gradeInputsByComm = {};
    var allCommodityInput = null;

    var initialSearch = window.location.search;
    var sitesMenuReady = false;
    var commodityMenuReady = false;
    var urlFiltersApplied = false;

    function getVal(row) {
        var keys = Array.prototype.slice.call(arguments, 1);
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (row[k] !== undefined && row[k] !== null) return row[k];
            var K = k.charAt(0).toUpperCase() + k.slice(1);
            if (row[K] !== undefined && row[K] !== null) return row[K];
        }
        return '';
    }
    function normalizeKey(value) {
        return String(value || '')
            .trim()
            .toLowerCase();
    }
    function rankValue(value) {
        var rank = Number(value);
        return isNaN(rank) ? Number.MAX_SAFE_INTEGER : rank;
    }
    function compareRankedItems(a, b) {
        var n = rankValue(a.rank) - rankValue(b.rank);
        if (n !== 0) return n;
        return String(a.description || '').localeCompare(
            String(b.description || ''),
            undefined,
            { sensitivity: 'base' }
        );
    }
    function setHidden(el, hidden) {
        if (el) el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }
    function showRegionError(failedNames) {
        if (!regionErrorEl) return;
        if (!failedNames.length) {
            setHidden(regionErrorEl, true);
            return;
        }
        if (regionErrorTextEl) {
            regionErrorTextEl.textContent = regionErrorTemplate.replace(
                '{region}',
                failedNames.join(', ')
            );
        }
        setHidden(regionErrorEl, false);
    }
    function setExportEnabled(enabled) {
        if (!exportBtn) return;
        exportBtn.disabled = !enabled;
        exportBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
    function extractArray(data) {
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.value)) return data.value;
        return [];
    }
    function findRegion(el, name) {
        return el ? el.querySelector('[data-region="' + name + '"]') : null;
    }
    function formatBoundText(value, format, fallback) {
        if (value === '' || value == null) return fallback || '';
        if (format === 'currency') return '$' + Number(value).toFixed(2);
        if (format === 'uppercase') return String(value).toUpperCase();
        return value;
    }
    function bindText(el, row) {
        if (!el) return;
        el.querySelectorAll('[data-bind-text]').forEach(function(target) {
            var keys = target.getAttribute('data-bind-text').split(',');
            var value = getVal.apply(null, [row].concat(keys));
            target.textContent = formatBoundText(
                value,
                target.getAttribute('data-bind-format'),
                target.getAttribute('data-bind-fallback') || ''
            );
        });
    }
    function getBindKeys(el, attr) {
        return String((el && el.getAttribute(attr)) || '')
            .split(',')
            .filter(function(key) {
                return key;
            });
    }
    function countUniqueValues(rows, keys) {
        var values = new Set();
        rows.forEach(function(row) {
            var value = getVal.apply(null, [row].concat(keys));
            if (value) values.add(value);
        });
        return values.size;
    }
    function formatLabel(template, label) {
        return String(template || '').replace('{label}', label || '');
    }
    function bindAriaLabel(el, label) {
        if (!el) return;
        el.setAttribute(
            'aria-label',
            formatLabel(el.getAttribute('data-aria-label'), label)
        );
    }

    function showLoading() {
        setHidden(loadingEl, false);
        setHidden(errorEl, true);
        setHidden(noResultsEl, true);
        setHidden(tableWrapper, true);
        setHidden(siteView, true);
        setHidden(commodityView, true);
        setHidden(filtersRow, true);
        setExportEnabled(false);
    }
    function showError() {
        setHidden(loadingEl, true);
        setHidden(errorEl, false);
        setHidden(noResultsEl, true);
        setHidden(tableWrapper, true);
        setHidden(siteView, true);
        setHidden(commodityView, true);
        setHidden(filtersRow, true);
        setExportEnabled(false);
    }
    function showNoRegionsConfigured() {
        setHidden(loadingEl, true);
        setHidden(errorEl, true);
        setHidden(noResultsEl, true);
        setHidden(tableWrapper, true);
        setHidden(siteView, true);
        setHidden(commodityView, true);
        setHidden(filtersRow, true);
        setHidden(noRegionsEl, false);
        setExportEnabled(false);
    }
    function getSelectedFilters() {
        var checkedComms = new Set();
        var checkedGrades = new Set();
        commodityMenuCheckboxes.forEach(function(item) {
            if (item.input.checked) checkedComms.add(item.commodityDesc);
        });
        gradeMenuCheckboxes.forEach(function(item) {
            if (item.input.checked)
                checkedGrades.add(item.commodityDesc + '::' + item.gradeDesc);
        });
        return {
            checkedComms: checkedComms,
            checkedGrades: checkedGrades,
        };
    }
    function hasSelectedSite() {
        return !sitesMenuReady || excludedSites.size < allSites.length;
    }
    function hasSelectedCommodity(filters) {
        if (!commodityMenuReady) return true;
        return filters.checkedComms.size > 0 || filters.checkedGrades.size > 0;
    }
    function updateGroupByAvailability(filters) {
        if (!groupByToggle) return;
        var enabled = hasSelectedSite() && hasSelectedCommodity(filters);
        groupByToggle.disabled = !enabled;
        groupByToggle.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        if (enabled) return;

        closeDropdown(groupByDropdownEl);
        if (groupBy === 'none') return;
        groupBy = 'none';
        activeCommodity = null;
        excludedGrades.clear();
        groupByRadios.forEach(function(radio) {
            radio.checked = radio.getAttribute('data-group-by') === 'none';
        });
        updateGroupByOptionState();
    }

    function rerenderKeepingScroll() {
        var scrollTop = commodityMenuScrollTop;
        applyFiltersAndRender();
        if (commodityMenuEl) commodityMenuEl.scrollTop = scrollTop;
        requestAnimationFrame(function() {
            if (commodityMenuEl) commodityMenuEl.scrollTop = scrollTop;
        });
    }

    function showResults(rows) {
        setHidden(loadingEl, true);
        setHidden(errorEl, true);
        setHidden(noResultsEl, rows.length > 0);
        setExportEnabled(rows.length > 0);

        if (rows.length === 0) {
            setHidden(tableWrapper, true);
            setHidden(siteView, true);
            setHidden(commodityView, true);
            setHidden(filtersRow, true);
            return;
        }
        setHidden(filtersRow, false);

        if (groupBy === 'site') {
            setHidden(tableWrapper, true);
            setHidden(commodityView, true);
            setHidden(siteView, false);
        } else if (groupBy === 'commodity') {
            setHidden(tableWrapper, true);
            setHidden(siteView, true);
            setHidden(commodityView, false);
        } else {
            setHidden(siteView, true);
            setHidden(commodityView, true);
            setHidden(tableWrapper, false);
            if (tableWrapper) {
                var firstRow = tableBody.querySelector(
                    'tr:not(.cash-pricing__group-header)'
                );
                var thead = tableWrapper.querySelector('thead');
                if (firstRow && thead) {
                    var rowH = firstRow.getBoundingClientRect().height;
                    var theadH = thead.getBoundingClientRect().height;
                    tableWrapper.style.maxHeight = theadH + rowH * 15 + 'px';
                }
            }
        }
    }

    function fetchSites() {
        if (REGION_NAMES.length) {
            fetchSitesFromRegions();
        } else {
            fetchSitesFromAll();
        }
    }

    function fetchSitesFromAll() {
        fetch(SITES_API, {
            headers: { Accept: 'application/json' },
        })
            .then(function(res) {
                return res.json();
            })
            .then(function(data) {
                allSites = extractArray(data)
                    .map(function(s) {
                        return {
                            id: getVal(s, 'id'),
                            description: getVal(s, 'site'),
                        };
                    })
                    .filter(function(s) {
                        return s.description;
                    });

                buildSiteMenu();
                fetchSiteGradeRanks(allSites);
            })
            .catch(function() {
            });
    }

    function fetchSitesFromRegions() {
        Promise.all(
            REGION_NAMES.map(function(name) {
                return fetch(REGIONS_API[name], {
                    headers: { Accept: 'application/json' },
                })
                    .then(function(res) {
                        if (!res.ok) throw new Error('HTTP ' + res.status);
                        return res.json();
                    })
                    .then(function(data) {
                        return { name: name, sites: extractArray(data) };
                    })
                    .catch(function() {
                        return { name: name, sites: null };
                    });
            })
        ).then(function(regionResults) {
            var seen = {};
            var union = [];
            var failedNames = [];
            regionResults.forEach(function(result) {
                if (result.sites === null) {
                    failedNames.push(result.name);
                    return;
                }
                result.sites.forEach(function(s) {
                    var description = getVal(s, 'site', 'description');
                    if (!description || seen[description]) return;
                    seen[description] = true;
                    union.push({
                        id: getVal(s, 'id'),
                        description: description,
                    });
                });
            });
            union.sort(function(a, b) {
                return a.description.localeCompare(b.description);
            });
            allSites = union;
            allSitesSet = new Set(
                union.map(function(s) {
                    return s.description;
                })
            );
            showRegionError(failedNames);

            buildSiteMenu();
            fetchSiteGradeRanks(allSites);
        });
    }

    function fetchSiteGradeRanks(sites) {
        if (!SITE_GRADE_API || !sites || !sites.length) return;
        var batches = [];
        for (var i = 0; i < sites.length; i += SITE_GRADE_BATCH) {
            batches.push(sites.slice(i, i + SITE_GRADE_BATCH));
        }
        Promise.all(
            batches.map(function(batch) {
                var filter = batch
                    .map(function(s) {
                        return (
                            "SiteDescription eq '" +
                            String(s.description).replace(/'/g, "''") +
                            "'"
                        );
                    })
                    .join(' or ');
                return fetch(buildUrl(SITE_GRADE_API, { filter: filter }), {
                    headers: { Accept: 'application/json' },
                })
                    .then(function(res) {
                        return res.ok ? res.json() : Promise.reject();
                    })
                    .then(function(data) {
                        extractArray(data).forEach(function(r) {
                            var commId = normalizeKey(getVal(r, 'commodityId'));
                            var rank = rankValue(getVal(r, 'commodityRank'));
                            if (!commId || rank === Number.MAX_SAFE_INTEGER)
                                return;
                            if (
                                commodityRankMap[commId] === undefined ||
                                rank < commodityRankMap[commId]
                            ) {
                                commodityRankMap[commId] = rank;
                            }
                        });
                    })
                    .catch(function() {});
            })
        ).then(function() {
            if (gradesLoaded) {
                applyCommodityRanks();
                buildCommodityMenu();
            }
        });
    }

    function fetchCommodities() {
        fetch(COMMODITY_API, {
            headers: { Accept: 'application/json' },
        })
            .then(function(res) {
                return res.json();
            })
            .then(function(data) {
                allCommodities = extractArray(data)
                    .map(function(c) {
                        return {
                            id: getVal(c, 'commodityId'),
                            description: getVal(c, 'commodity'),
                            rank: Number.MAX_SAFE_INTEGER,
                        };
                    })
                    .filter(function(c) {
                        return c.description;
                    });

                var fetches = allCommodities.map(function(c) {
                    var url = buildUrl(GRADES_API, { id: c.id });
                    return fetch(url, {
                        headers: { Accept: 'application/json' },
                    })
                        .then(function(res) {
                            return res.json();
                        })
                        .then(function(data) {
                            allGrades[c.id] = extractArray(data)
                                .map(function(g) {
                                    return {
                                        id: getVal(g, 'gradeId'),
                                        description: getVal(g, 'grade'),
                                        rank: rankValue(getVal(g, 'gradeRank')),
                                    };
                                })
                                .filter(function(g) {
                                    return g.description;
                                })
                                .sort(compareRankedItems);
                        })
                        .catch(function() {
                            allGrades[c.id] = [];
                        });
                });

                Promise.all(fetches).then(function() {
                    gradesLoaded = true;
                    applyCommodityRanks();
                    buildCommodityMenu();
                });
            })
            .catch(function() {
                commodityMenuReady = true;
                maybeApplyUrlFilters();
            });
    }

    if (poolCheck) poolCheck.addEventListener('change', applyFiltersAndRender);
    if (extendedCheck)
        extendedCheck.addEventListener('change', applyFiltersAndRender);

    function createCheckItem(opts) {
        var li = clonePrototype(opts.prototype);

        var input = li.querySelector('input');
        input.id = opts.id;
        input.checked = !!opts.checked;
        if (opts.attrs) {
            Object.keys(opts.attrs).forEach(function(name) {
                input.setAttribute(name, opts.attrs[name]);
            });
        }

        var label = li.querySelector('label');
        label.setAttribute('for', opts.id);

        if (opts.text !== undefined) {
            li.querySelector('[data-region="checkItemText"]').textContent =
                opts.text;
        }

        li.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        return { li: li, input: input };
    }

    function sortBuyerRows(rows) {
        return rows.slice().sort(function(a, b) {
            var pa = parseFloat(getVal(a, 'price', 'cashPrice'));
            var pb = parseFloat(getVal(b, 'price', 'cashPrice'));
            if (isNaN(pa)) pa = -Infinity;
            if (isNaN(pb)) pb = -Infinity;
            if (pb !== pa) return pb - pa;
            var ba = String(getVal(a, 'ownerDescription', 'buyerName', 'buyer') || '');
            var bb = String(getVal(b, 'ownerDescription', 'buyerName', 'buyer') || '');
            return ba.localeCompare(bb);
        });
    }

    function createDetailPanel(rows) {
        var detailPanel = clonePrototype(
            'detailPanelPrototype',
            '.cash-pricing__grade-detail'
        );
        var detailTable = findRegion(detailPanel, 'detailTable');
        var rowPrototype = findRegion(detailPanel, 'detailRowPrototype');
        if (!detailTable || !rowPrototype) return detailPanel;

        rowPrototype.parentNode.removeChild(rowPrototype);
        rows.forEach(function(row) {
            var detailRow = rowPrototype.cloneNode(true);
            bindText(detailRow, row);
            detailTable.appendChild(detailRow);
        });

        return detailPanel;
    }

    function wireMoreDetails(
        gradeRow,
        detailPanel,
        moreBtn,
        moreBtnText,
        label
    ) {
        var collapsedText = moreBtn.getAttribute('data-collapsed-text') || '';
        var expandedText = moreBtn.getAttribute('data-expanded-text') || '';
        var collapsedAria = moreBtn.getAttribute('data-collapsed-aria-label');
        var expandedAria = moreBtn.getAttribute('data-expanded-aria-label');

        moreBtn.setAttribute('aria-label', formatLabel(collapsedAria, label));
        moreBtn.addEventListener('click', function() {
            var isOpen = detailPanel.getAttribute('aria-hidden') === 'false';
            detailPanel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
            moreBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            moreBtn.setAttribute(
                'aria-label',
                formatLabel(isOpen ? collapsedAria : expandedAria, label)
            );
            moreBtnText.textContent = isOpen ? collapsedText : expandedText;
        });
        moreBtn.addEventListener('keydown', function(e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            moreBtn.click();
        });
        gradeRow.addEventListener('click', function(e) {
            if (e.target === moreBtn || moreBtn.contains(e.target)) return;
            moreBtn.click();
        });
    }

    function buildSiteMenu() {
        if (!siteMenuEl) return;
        siteMenuEl.replaceChildren();

        var allItem = createCheckItem({
            prototype: 'siteAllCheckItemPrototype',
            id: 'site-cb-all',
            checked: true,
            attrs: { 'data-site-all': '' },
        });
        var allCb = allItem.input;
        siteMenuEl.appendChild(allItem.li);
        allCb.addEventListener('change', function() {
            var checked = allCb.checked;
            if (checked) {
                excludedSites.clear();
            } else {
                allSites.forEach(function(s) {
                    excludedSites.add(s.description);
                });
            }
            siteMenuEl.querySelectorAll('[data-site]').forEach(function(cb) {
                cb.checked = checked;
            });
            applyFiltersAndRender();
        });

        allSites.forEach(function(site, idx) {
            var item = createCheckItem({
                prototype: 'siteCheckItemPrototype',
                id: 'site-cb-' + idx,
                text: site.description,
                checked: true,
                attrs: { 'data-site': site.description },
            });
            var cb = item.input;
            siteMenuEl.appendChild(item.li);
            cb.addEventListener('change', function() {
                if (cb.checked) {
                    excludedSites.delete(site.description);
                } else {
                    excludedSites.add(site.description);
                }
                allCb.checked = excludedSites.size === 0;
                applyFiltersAndRender();
            });
        });

        if (siteSearchEl) {
            siteSearchEl.value = '';
            siteSearchEl.oninput = function(e) {
                e.stopPropagation();
                var term = siteSearchEl.value.trim().toLowerCase();
                siteMenuEl
                    .querySelectorAll('[data-site]')
                    .forEach(function(cb) {
                        var li = cb.closest('.cash-pricing__dropdown-item');
                        if (!li) return;
                        var name = (
                            cb.getAttribute('data-site') || ''
                        ).toLowerCase();
                        li.style.display =
                            !term || name.indexOf(term) !== -1 ? '' : 'none';
                    });
            };
            siteSearchEl.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
        if (siteSearchEl && siteSearchEl.parentElement) {
            siteSearchEl.parentElement.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }

        sitesMenuReady = true;
        maybeApplyUrlFilters();
    }

    function buildCommodityMenu() {
        if (!commodityMenuEl) return;
        var previousFilters = getSelectedFilters();
        var preserveSelection =
            urlFiltersApplied &&
            (commodityMenuCheckboxes.length > 0 ||
                gradeMenuCheckboxes.length > 0);
        commodityMenuEl.replaceChildren();

        commodityMenuCheckboxes = [];
        gradeMenuCheckboxes = [];
        gradeInputsByComm = {};
        allCommodityInput = null;

        function makeCommodityItem(ci, commodityDesc) {
            var item = createCheckItem({
                prototype: 'commodityCheckItemPrototype',
                id: 'cp-cb-c' + ci,
                text: commodityDesc,
                checked: preserveSelection
                    ? previousFilters.checkedComms.has(commodityDesc)
                    : true,
            });
            var input = item.input;
            commodityMenuCheckboxes.push({
                input: input,
                commodityDesc: commodityDesc,
            });
            input.addEventListener('change', function() {
                (gradeInputsByComm[commodityDesc] || []).forEach(function(g) {
                    g.checked = input.checked;
                });
                clearExcludedGradesFor(commodityDesc);
                syncAllCommodityState();
                rerenderKeepingScroll();
            });
            return item.li;
        }

        function makeGradeItem(ci, gi, commodityDesc, gradeDesc) {
            var item = createCheckItem({
                prototype: 'gradeCheckItemPrototype',
                id: 'cp-cb-g' + ci + '-' + gi,
                text: gradeDesc,
                checked: preserveSelection
                    ? previousFilters.checkedComms.has(commodityDesc) ||
                      previousFilters.checkedGrades.has(
                          commodityDesc + '::' + gradeDesc
                      )
                    : true,
            });
            var input = item.input;
            gradeMenuCheckboxes.push({
                input: input,
                commodityDesc: commodityDesc,
                gradeDesc: gradeDesc,
            });
            if (!gradeInputsByComm[commodityDesc])
                gradeInputsByComm[commodityDesc] = [];
            gradeInputsByComm[commodityDesc].push(input);
            input.addEventListener('change', function() {
                if (input.checked)
                    excludedGrades.delete(commodityDesc + '::' + gradeDesc);
                syncCommodityStateFromGrades(commodityDesc);
                syncAllCommodityState();
                rerenderKeepingScroll();
            });
            return item.li;
        }

        var allItem = createCheckItem({
            prototype: 'commodityAllCheckItemPrototype',
            id: 'cp-cb-all',
            checked: true,
        });
        var allInput = allItem.input;
        allInput.addEventListener('change', function() {
            var check = allInput.checked;
            commodityMenuCheckboxes.forEach(function(item) {
                item.input.checked = check;
            });
            gradeMenuCheckboxes.forEach(function(item) {
                item.input.checked = check;
            });
            excludedGrades.clear();
            rerenderKeepingScroll();
        });
        allCommodityInput = allInput;
        commodityMenuEl.appendChild(allItem.li);

        var pricedGrades = {};
        allData.forEach(function(row) {
            if (!isGrowerCashPricingRow(row)) return;
            var site = getVal(row, 'siteDescription', 'siteName');
            if (allSitesSet && !allSitesSet.has(site)) return;
            var cDesc = getVal(row, 'commodityDescription', 'commodity');
            var gDesc = getVal(row, 'grade');
            if (!cDesc || !gDesc) return;
            var key = normalizeKey(cDesc);
            if (!pricedGrades[key]) pricedGrades[key] = new Set();
            pricedGrades[key].add(normalizeKey(gDesc));
        });

        allCommodities.forEach(function(c, ci) {
            var priced = pricedGrades[normalizeKey(c.description)];
            if (!priced) return;
            var grades = (allGrades[c.id] || []).filter(function(g) {
                return priced.has(normalizeKey(g.description));
            });
            if (grades.length === 0) return;
            commodityMenuEl.appendChild(makeCommodityItem(ci, c.description));
            grades.forEach(function(g, gi) {
                commodityMenuEl.appendChild(
                    makeGradeItem(ci, gi, c.description, g.description)
                );
            });
        });

        if (preserveSelection) {
            commodityMenuCheckboxes.forEach(function(it) {
                syncCommodityStateFromGrades(it.commodityDesc);
            });
            syncAllCommodityState();
        }

        commodityMenuReady = true;
        maybeApplyUrlFilters();
    }

    function clearExcludedGradesFor(commodityDesc) {
        var prefix = commodityDesc + '::';
        excludedGrades.forEach(function(key) {
            if (key.indexOf(prefix) === 0) excludedGrades.delete(key);
        });
    }

    function uncheckGradeInMenu(commodityDesc, gradeDesc) {
        for (var i = 0; i < gradeMenuCheckboxes.length; i++) {
            var item = gradeMenuCheckboxes[i];
            if (
                item.commodityDesc === commodityDesc &&
                item.gradeDesc === gradeDesc
            ) {
                item.input.checked = false;
                break;
            }
        }
        syncCommodityStateFromGrades(commodityDesc);
        syncAllCommodityState();
    }

    function syncCommodityStateFromGrades(commodityDesc) {
        var grades = gradeInputsByComm[commodityDesc] || [];
        if (grades.length === 0) return;
        var allChecked = true;
        for (var i = 0; i < grades.length; i++) {
            if (!grades[i].checked) {
                allChecked = false;
                break;
            }
        }
        for (var ci = 0; ci < commodityMenuCheckboxes.length; ci++) {
            if (commodityMenuCheckboxes[ci].commodityDesc === commodityDesc) {
                commodityMenuCheckboxes[ci].input.checked = allChecked;
                break;
            }
        }
    }

    function syncAllCommodityState() {
        if (!allCommodityInput) return;
        var allChecked =
            commodityMenuCheckboxes.length > 0 &&
            gradeMenuCheckboxes.length > 0;
        for (var ci = 0; ci < commodityMenuCheckboxes.length; ci++) {
            if (!commodityMenuCheckboxes[ci].input.checked) {
                allChecked = false;
                break;
            }
        }
        if (allChecked) {
            for (var gi = 0; gi < gradeMenuCheckboxes.length; gi++) {
                if (!gradeMenuCheckboxes[gi].input.checked) {
                    allChecked = false;
                    break;
                }
            }
        }
        allCommodityInput.checked = allChecked;
    }

    function applyCommodityRanks() {
        var commoditiesById = {};
        var commoditiesByDescription = {};
        allCommodities.forEach(function(c) {
            c.rank = Number.MAX_SAFE_INTEGER;
            commoditiesById[normalizeKey(c.id)] = c;
            commoditiesByDescription[normalizeKey(c.description)] = c;
        });

        allCommodities.forEach(function(c) {
            var rank = commodityRankMap[normalizeKey(c.id)];
            if (rank !== undefined && rank < c.rank) c.rank = rank;
        });

        allData.forEach(function(row) {
            if (!isGrowerCashPricingRow(row)) return;
            var rank = rankValue(getVal(row, 'commodityRank'));
            if (rank === Number.MAX_SAFE_INTEGER) return;
            var commodity =
                commoditiesById[normalizeKey(getVal(row, 'commodityId'))] ||
                commoditiesByDescription[
                    normalizeKey(
                        getVal(row, 'commodityDescription', 'commodity')
                    )
                ];
            if (commodity && rank < commodity.rank) {
                commodity.rank = rank;
            }
        });

        allCommodities.sort(compareRankedItems);
    }

    var allDropdowns = [siteDropdownEl, commodityDropdownEl, groupByDropdownEl];

    function syncDropdownOpenState() {
        var anyOpen = allDropdowns.some(function(d) {
            return d && d.classList.contains('-open');
        });
        root.classList.toggle('cash-pricing--dropdown-open', anyOpen);
    }

    function openDropdown(el) {
        allDropdowns.forEach(function(d) {
            if (d && d !== el) closeDropdown(d);
        });
        if (!el) return;
        el.classList.add('-open');
        var btn = el.querySelector('[aria-expanded]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        syncDropdownOpenState();
    }

    function closeDropdown(el) {
        if (!el) return;
        el.classList.remove('-open');
        var btn = el.querySelector('[aria-expanded]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        syncDropdownOpenState();
    }

    function closeAllDropdowns() {
        allDropdowns.forEach(function(d) {
            closeDropdown(d);
        });
    }

    function setupDropdownKeyboard(toggleEl, dropdownEl, menuEl, searchEl) {
        if (!toggleEl || !dropdownEl || !menuEl) return;

        function visibleInputs() {
            return Array.prototype.slice
                .call(menuEl.querySelectorAll('.cash-pricing__filter-check'))
                .filter(function(input) {
                    var item = input.closest('.cash-pricing__dropdown-item');
                    return !item || item.style.display !== 'none';
                });
        }

        function focusFirst() {
            requestAnimationFrame(function() {
                var items = visibleInputs();
                if (items.length) items[0].focus();
            });
        }

        function focusLast() {
            requestAnimationFrame(function() {
                var items = visibleInputs();
                if (items.length) items[items.length - 1].focus();
            });
        }

        dropdownEl.addEventListener('focusout', function(e) {
            if (e.relatedTarget && !dropdownEl.contains(e.relatedTarget)) {
                closeDropdown(dropdownEl);
            }
        });

        toggleEl.addEventListener('keydown', function(e) {
            var isOpen = dropdownEl.classList.contains('-open');
            if (e.key === 'Escape') {
                if (isOpen) {
                    closeDropdown(dropdownEl);
                    toggleEl.focus();
                    e.preventDefault();
                }
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!isOpen) openDropdown(dropdownEl);
                focusFirst();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!isOpen) openDropdown(dropdownEl);
                focusLast();
            }
        });

        menuEl.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeDropdown(dropdownEl);
                toggleEl.focus();
                e.preventDefault();
                return;
            }
            if (e.key === ' ' || e.key === 'Enter') {
                var input = document.activeElement;
                if (
                    input &&
                    input.classList.contains('cash-pricing__filter-check')
                ) {
                    e.preventDefault();
                    if (input.type === 'radio') {
                        input.checked = true;
                    } else {
                        input.checked = !input.checked;
                    }
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
                return;
            }
            if (
                e.key !== 'ArrowDown' &&
                e.key !== 'ArrowUp' &&
                e.key !== 'Home' &&
                e.key !== 'End'
            )
                return;
            e.preventDefault();
            var items = visibleInputs();
            if (!items.length) return;
            var idx = items.indexOf(document.activeElement);
            var next;
            if (e.key === 'ArrowDown') {
                next = idx < items.length - 1 ? items[idx + 1] : items[0];
            } else if (e.key === 'ArrowUp') {
                next = idx > 0 ? items[idx - 1] : items[items.length - 1];
            } else if (e.key === 'Home') {
                next = items[0];
            } else {
                next = items[items.length - 1];
            }
            next.focus();
        });

        if (searchEl) {
            searchEl.addEventListener('keydown', function(e) {
                if (e.key === 'Escape') {
                    closeDropdown(dropdownEl);
                    toggleEl.focus();
                    e.preventDefault();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    focusFirst();
                }
            });
        }
    }

    function setupIncludeFilterKeyboard(input) {
        if (!input) return;
        input.addEventListener('keydown', function(e) {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            input.click();
        });
    }

    setupIncludeFilterKeyboard(poolCheck);
    setupIncludeFilterKeyboard(extendedCheck);

    function updateGroupByOptionState() {
        if (!groupByMenuEl) return;
        var options = groupByMenuEl.querySelectorAll(
            '.cash-pricing__dropdown-item'
        );
        Array.prototype.forEach.call(options, function(option) {
            var radio = option.querySelector('[data-group-by]');
            var selected = radio && radio.checked;
            option.setAttribute('aria-selected', selected ? 'true' : 'false');
            option.setAttribute('tabindex', '0');
            if (radio) radio.setAttribute('tabindex', '-1');
        });
    }

    function setupGroupByKeyboard() {
        if (!groupByToggle || !groupByDropdownEl || !groupByMenuEl) return;

        function options() {
            return Array.prototype.slice.call(
                groupByMenuEl.querySelectorAll('.cash-pricing__dropdown-item')
            );
        }

        function focusOption(index) {
            var items = options();
            if (!items.length) return;
            if (index < 0) index = items.length - 1;
            if (index >= items.length) index = 0;
            items[index].focus();
        }

        function selectOption(option) {
            if (!option) return;
            var radio = option.querySelector('[data-group-by]');
            if (!radio) return;

            if (
                radio.checked &&
                radio.getAttribute('data-group-by') !== 'none'
            ) {
                var noneRadio = groupByMenuEl.querySelector(
                    '[data-group-by="none"]'
                );
                if (!noneRadio) return;
                noneRadio.checked = true;
                noneRadio.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (!radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
            updateGroupByOptionState();
        }

        groupByToggle.addEventListener('keydown', function(e) {
            var isOpen = groupByDropdownEl.classList.contains('-open');
            if (e.key === 'Escape') {
                if (isOpen) {
                    closeDropdown(groupByDropdownEl);
                    groupByToggle.focus();
                    e.preventDefault();
                }
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!isOpen) openDropdown(groupByDropdownEl);
                requestAnimationFrame(function() {
                    focusOption(0);
                });
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!isOpen) openDropdown(groupByDropdownEl);
                requestAnimationFrame(function() {
                    focusOption(options().length - 1);
                });
            }
        });

        groupByMenuEl.addEventListener('keydown', function(e) {
            var option = e.target.closest
                ? e.target.closest('.cash-pricing__dropdown-item')
                : null;
            if (!option || !groupByMenuEl.contains(option)) return;

            var items = options();
            var idx = items.indexOf(option);

            if (e.key === 'Escape') {
                closeDropdown(groupByDropdownEl);
                groupByToggle.focus();
                e.preventDefault();
            } else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                selectOption(option);
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                focusOption(idx + 1);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                focusOption(idx - 1);
            } else if (e.key === 'Home') {
                e.preventDefault();
                focusOption(0);
            } else if (e.key === 'End') {
                e.preventDefault();
                focusOption(items.length - 1);
            }
        });

        groupByMenuEl.addEventListener('click', function(e) {
            var option = e.target.closest
                ? e.target.closest('.cash-pricing__dropdown-item')
                : null;
            if (!option || !groupByMenuEl.contains(option)) return;
            selectOption(option);
        });

        groupByDropdownEl.addEventListener('focusout', function(e) {
            if (
                e.relatedTarget &&
                !groupByDropdownEl.contains(e.relatedTarget)
            ) {
                closeDropdown(groupByDropdownEl);
            }
        });

        updateGroupByOptionState();
    }

    function fetchPricing() {
        if (!REGION_NAMES.length) {
            showNoRegionsConfigured();
            return;
        }
        showLoading();
        fetch(PRICING_API, {
            headers: { Accept: 'application/json' },
        })
            .then(function(res) {
                if (!res.ok) throw new Error('HTTP ' + res.status);
                return res.json();
            })
            .then(function(data) {
                allData = extractArray(data);

                applyCommodityRanks();
                if (gradesLoaded) buildCommodityMenu();

                updateRefreshTime();

                if (!REGION_NAMES.length && allSites.length === 0) {
                    var seen = {};
                    allData.forEach(function(row) {
                        var s = getVal(row, 'siteDescription', 'siteName');
                        if (s && !seen[s]) {
                            seen[s] = true;
                            allSites.push({
                                id: s,
                                description: s,
                            });
                        }
                    });
                    allSites.sort(function(a, b) {
                        return a.description.localeCompare(b.description);
                    });
                    buildSiteMenu();
                }

                applyFiltersAndRender();
            })
            .catch(function() {
                showError();
            });
    }

    function updateRefreshTime() {
        if (!refreshSpan) return;
        var now = new Date();
        var tz =
            Intl && Intl.DateTimeFormat
                ? Intl.DateTimeFormat().resolvedOptions().timeZone
                : 'local';
        refreshSpan.textContent = now.toLocaleString() + ' (' + tz + ')';
    }

    function isGrowerCashPricingRow(row) {
        return (
            getVal(row, 'isGrowerBuyer') !== false &&
            getVal(row, 'isEzigrainBuyer') !== false
        );
    }

    function applyFiltersAndRender() {
        updateRefreshTime();
        var includePool = poolCheck ? poolCheck.checked : true;
        var includeExtended = extendedCheck ? extendedCheck.checked : true;

        var cgFilters = getSelectedFilters();
        updateGroupByAvailability(cgFilters);

        var base = allData.filter(function(row) {
            if (!isGrowerCashPricingRow(row)) return false;

            var site = getVal(row, 'siteDescription', 'siteName');
            if (allSitesSet && !allSitesSet.has(site)) return false;
            if (excludedSites.size > 0 && excludedSites.has(site)) return false;

            var payCategory = (
                getVal(row, 'paymentCategory') || ''
            ).toLowerCase();
            if (!includePool && payCategory === 'pool') return false;

            var sOptionType = (
                getVal(row, 'sellingOptionType') || ''
            ).toLowerCase();
            if (
                !includeExtended &&
                payCategory === 'cash' &&
                sOptionType === 'ep'
            )
                return false;

            return true;
        });

        var filtered = base.filter(function(row) {
            if (!commodityMenuReady) return true;
            var cDesc = getVal(row, 'commodityDescription', 'commodity');
            var gDesc = getVal(
                row,
                'gradeDescription',
                'grade',
                'gradeName',
                'gradeCode'
            );
            return (
                cgFilters.checkedComms.has(cDesc) ||
                cgFilters.checkedGrades.has(cDesc + '::' + gDesc)
            );
        });

        commodityTabsWithData.clear();
        if (groupBy === 'commodity') {
            filtered.forEach(function(row) {
                commodityTabsWithData.add(
                    getVal(row, 'commodityDescription', 'commodity') || '—'
                );
            });

            if (excludedGrades.size > 0) {
                var commoditiesInBase = new Set();
                base.forEach(function(row) {
                    commoditiesInBase.add(
                        getVal(row, 'commodityDescription', 'commodity') || '—'
                    );
                });
                excludedGrades.forEach(function(key) {
                    var c = key.slice(0, key.indexOf('::'));
                    if (commoditiesInBase.has(c)) commodityTabsWithData.add(c);
                });

                filtered = filtered.filter(function(row) {
                    var c =
                        getVal(row, 'commodityDescription', 'commodity') || '—';
                    var g =
                        getVal(
                            row,
                            'gradeDescription',
                            'grade',
                            'gradeName',
                            'gradeCode'
                        ) || '—';
                    return !excludedGrades.has(c + '::' + g);
                });
            }
        }

        filtered.sort(function(a, b) {
            var siteA = getVal(a, 'siteDescription', 'siteName') || '';
            var siteB = getVal(b, 'siteDescription', 'siteName') || '';
            return siteA.localeCompare(siteB);
        });

        renderTable(filtered);
        showResults(filtered);
        updateUrl();
    }

    function buildDataRow(row) {
        var tr = clonePrototype('dataRowPrototype');
        bindText(tr, row);
        return tr;
    }

    function cmpStr(a, b, dir) {
        var n = a === b ? 0 : a < b ? -1 : 1;
        return dir === 'asc' ? n : -n;
    }
    function cmpNum(a, b, dir) {
        return dir === 'asc' ? a - b : b - a;
    }
    function getCommodityRankIndex(commDesc) {
        for (var i = 0; i < allCommodities.length; i++) {
            if (allCommodities[i].description === commDesc) return i;
        }
        return Number.MAX_SAFE_INTEGER;
    }

    function getGradeRankIndex(commDesc, gradeDesc) {
        for (var ci = 0; ci < allCommodities.length; ci++) {
            if (allCommodities[ci].description !== commDesc) continue;
            var grades = allGrades[allCommodities[ci].id] || [];
            for (var gi = 0; gi < grades.length; gi++) {
                if (grades[gi].description === gradeDesc) return gi;
            }
            return Number.MAX_SAFE_INTEGER;
        }
        return Number.MAX_SAFE_INTEGER;
    }
    var SORT_FIELDS = {
        site: {
            get: function(r) {
                return getVal(r, 'siteDescription', 'siteName') || '';
            },
            cmp: cmpStr,
        },
        commodity: {
            get: function(r) {
                return getCommodityRankIndex(
                    getVal(r, 'commodityDescription', 'commodity') || ''
                );
            },
            cmp: cmpNum,
        },
        grade: {
            get: function(r) {
                return getGradeRankIndex(
                    getVal(r, 'commodityDescription', 'commodity') || '',
                    getVal(
                        r,
                        'gradeDescription',
                        'grade',
                        'gradeName',
                        'gradeCode'
                    ) || ''
                );
            },
            cmp: cmpNum,
        },
        buyer: {
            get: function(r) {
                return (
                    getVal(r, 'ownerDescription', 'buyerName', 'buyer') || ''
                );
            },
            cmp: cmpStr,
        },
        price: {
            get: function(r) {
                var p = getVal(r, 'price', 'cashPrice');
                return p === '' ? 0 : Number(p);
            },
            cmp: cmpNum,
        },
        priceType: {
            get: function(r) {
                return (
                    getVal(
                        r,
                        'sellingOptionDescription',
                        'priceType',
                        'purchaseOption'
                    ) || ''
                );
            },
            cmp: cmpStr,
        },
        payment: {
            get: function(r) {
                return (
                    getVal(r, 'paymentTerms', 'paymentTermDescription') || ''
                );
            },
            cmp: cmpStr,
        },
    };

    var SORT_CHAINS = {
        site: [
            ['site', 'flip'],
            ['commodity', 'asc'],
            ['grade', 'desc'],
            ['price', 'desc'],
        ],
        commodity: [
            ['commodity', 'flip'],
            ['grade', 'desc'],
            ['site', 'asc'],
            ['price', 'desc'],
        ],
        grade: [
            ['commodity', 'asc'],
            ['grade', 'active'],
            ['site', 'asc'],
            ['price', 'desc'],
        ],
        buyer: [
            ['buyer', 'active'],
            ['site', 'asc'],
            ['commodity', 'asc'],
            ['grade', 'desc'],
            ['price', 'desc'],
        ],
        price: [
            ['price', 'active'],
            ['site', 'asc'],
            ['commodity', 'asc'],
            ['grade', 'desc'],
        ],
        priceType: [
            ['priceType', 'active'],
            ['site', 'asc'],
            ['commodity', 'asc'],
            ['grade', 'desc'],
        ],
        payment: [
            ['payment', 'active'],
            ['site', 'asc'],
            ['commodity', 'asc'],
            ['grade', 'desc'],
        ],
    };

    function resolveDir(token) {
        if (token === 'active') return sortDir;
        if (token === 'flip') return sortDir !== 'asc' ? 'asc' : 'desc';
        return token;
    }

    function sortRows(rows) {
        if (sortDir === 'default') {
            return rows.slice().sort(function(a, b) {
                var sa = SORT_FIELDS.site.get(a);
                var sb = SORT_FIELDS.site.get(b);
                var n = cmpStr(sa, sb, 'asc');
                if (n !== 0) return n;
                var ca = SORT_FIELDS.commodity.get(a);
                var cb = SORT_FIELDS.commodity.get(b);
                var ra = getCommodityRankIndex(ca);
                var rb = getCommodityRankIndex(cb);
                n = ra - rb;
                if (n !== 0) return n;
                if (
                    ra === Number.MAX_SAFE_INTEGER &&
                    rb === Number.MAX_SAFE_INTEGER
                ) {
                    n = cmpStr(ca, cb, 'asc');
                    if (n !== 0) return n;
                }
                var ga = SORT_FIELDS.grade.get(a);
                var gb = SORT_FIELDS.grade.get(b);
                var rga = getGradeRankIndex(ca, ga);
                var rgb = getGradeRankIndex(cb, gb);
                n = rga - rgb;
                if (n !== 0) return n;
                if (
                    rga === Number.MAX_SAFE_INTEGER &&
                    rgb === Number.MAX_SAFE_INTEGER
                ) {
                    n = cmpStr(ga, gb, 'asc');
                    if (n !== 0) return n;
                }
                n = cmpNum(
                    SORT_FIELDS.price.get(a),
                    SORT_FIELDS.price.get(b),
                    'desc'
                );
                if (n !== 0) return n;
                return cmpStr(
                    SORT_FIELDS.buyer.get(a),
                    SORT_FIELDS.buyer.get(b),
                    'asc'
                );
            });
        }
        var chain = SORT_CHAINS[sortBy];
        if (!chain) return rows.slice();
        return rows.slice().sort(function(a, b) {
            for (var i = 0; i < chain.length; i++) {
                var field = SORT_FIELDS[chain[i][0]];
                var n = field.cmp(
                    field.get(a),
                    field.get(b),
                    resolveDir(chain[i][1])
                );
                if (n !== 0) return n;
            }
            return 0;
        });
    }

    function getSortDir(key) {
        return sortBy !== key || sortDir === 'default' ? 'default' : sortDir;
    }

    function sortTable(key) {
        if (sortBy !== key) {
            sortBy = key;
            sortDir = 'desc';
        } else {
            sortDir =
                sortDir === 'desc'
                    ? 'asc'
                    : sortDir === 'asc'
                    ? 'default'
                    : 'desc';
        }
        renderTable(currentTableRows);
    }

    function eachSortHeader(fn) {
        var ths = root.querySelectorAll('[data-sort]');
        for (var i = 0; i < ths.length; i++) {
            fn(ths[i], ths[i].getAttribute('data-sort'));
        }
    }

    function updateSortIndicators() {
        eachSortHeader(function(th, key) {
            var dir = getSortDir(key);
            th.classList.remove(
                'cash-pricing__th--asc',
                'cash-pricing__th--desc',
                'cash-pricing__th--default'
            );
            th.classList.add('cash-pricing__th--' + dir);
            th.setAttribute(
                'aria-sort',
                dir === 'asc'
                    ? 'ascending'
                    : dir === 'desc'
                    ? 'descending'
                    : 'none'
            );
        });
    }

    function setupSortHeaders() {
        eachSortHeader(function(th, key) {
            var label = th.textContent.replace(/\s+/g, ' ').trim();
            bindAriaLabel(th, label);
            th.addEventListener('click', function() {
                sortTable(key);
            });
            th.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    sortTable(key);
                }
            });
        });
    }

    function renderTable(rows) {
        if (groupBy === 'site') {
            renderSiteView(rows);
            return;
        }
        if (groupBy === 'commodity') {
            renderCommodityView(rows);
            return;
        }

        if (!tableBody) return;
        tableBody.replaceChildren();

        if (groupBy === 'none') {
            currentTableRows = rows;
            sortRows(rows).forEach(function(row) {
                tableBody.appendChild(buildDataRow(row));
            });
            updateSortIndicators();
            return;
        }

        var keyFn =
            groupBy === 'site'
                ? function(row) {
                      return getVal(row, 'siteDescription', 'siteName') || '—';
                  }
                : function(row) {
                      return (
                          getVal(row, 'commodityDescription', 'commodity') ||
                          '—'
                      );
                  };

        var groups = [];
        var groupMap = {};
        rows.forEach(function(row) {
            var key = keyFn(row);
            if (!groupMap[key]) {
                groupMap[key] = [];
                groups.push(key);
            }
            groupMap[key].push(row);
        });
        groups.sort(function(a, b) {
            return a.localeCompare(b);
        });

        groups.forEach(function(key) {
            var headerTr = clonePrototype('groupHeaderPrototype');
            bindText(headerTr, { heading: key });
            tableBody.appendChild(headerTr);
            groupMap[key].forEach(function(row) {
                tableBody.appendChild(buildDataRow(row));
            });
        });
    }

    function renderCommodityView(rows) {
        if (!commodityView) return;
        commodityView.replaceChildren();

        var commNames = [];
        var commMap = {};
        rows.forEach(function(row) {
            var comm = getVal(row, 'commodityDescription', 'commodity') || '—';
            var grade =
                getVal(
                    row,
                    'gradeDescription',
                    'grade',
                    'gradeName',
                    'gradeCode'
                ) || '—';
            if (!commMap[comm]) {
                commMap[comm] = { gradeNames: [], gradeMap: {} };
                commNames.push(comm);
            }
            if (!commMap[comm].gradeMap[grade]) {
                commMap[comm].gradeMap[grade] = [];
                commMap[comm].gradeNames.push(grade);
            }
            commMap[comm].gradeMap[grade].push(row);
        });

        commodityTabsWithData.forEach(function(comm) {
            if (!commMap[comm]) {
                commMap[comm] = { gradeNames: [], gradeMap: {} };
                commNames.push(comm);
            }
        });

        if (commNames.length === 0) return;

        commNames.sort(function(a, b) {
            var ra = getCommodityRankIndex(a);
            var rb = getCommodityRankIndex(b);
            var n = ra - rb;
            if (n !== 0) return n;
            return cmpStr(a, b, 'asc');
        });

        var activeIdx = commNames.indexOf(activeCommodity);
        if (activeIdx === -1) activeIdx = 0;
        activeCommodity = commNames[activeIdx];

        var commodityContent = clonePrototype(
            'commodityViewPrototype',
            '.cash-pricing__commodity-content'
        );
        var tabsWrap = findRegion(commodityContent, 'tabsWrap');
        var tabsEl = findRegion(commodityContent, 'tabs');
        var panelsEl = findRegion(commodityContent, 'panels');
        commodityView.appendChild(commodityContent);

        if (commodityView && !commodityView.dataset.accordionWired) {
            commodityView.dataset.accordionWired = '1';
            document.addEventListener('click', function(e) {
                var openTabs = commodityView.querySelector(
                    '.cash-pricing__comm-tabs.-open'
                );
                if (openTabs && !openTabs.contains(e.target))
                    openTabs.classList.remove('-open');
            });
        }

        var panels = {};
        var tabs = [];

        function scrollActiveCommodityTabIntoView(activeTab) {
            if (!activeTab || tabsWrap.scrollWidth <= tabsWrap.clientWidth)
                return;

            window.requestAnimationFrame(function() {
                var wrapRect = tabsWrap.getBoundingClientRect();
                var tabRect = activeTab.getBoundingClientRect();
                tabsWrap.scrollLeft += tabRect.left - wrapRect.left;
            });
        }

        function activateCommodityTab(activeTab, activePanel) {
            tabs.forEach(function(t) {
                var isActive = t === activeTab;
                t.classList.toggle('-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                t.setAttribute('tabindex', '0');
            });
            commNames.forEach(function(k) {
                panels[k].setAttribute(
                    'aria-hidden',
                    panels[k] === activePanel ? 'false' : 'true'
                );
            });
            scrollActiveCommodityTabIntoView(activeTab);
        }

        function focusCommodityTab(currentTab, direction) {
            var idx = tabs.indexOf(currentTab);
            if (idx === -1) return;
            var nextIdx = idx + direction;
            if (nextIdx < 0) nextIdx = tabs.length - 1;
            if (nextIdx >= tabs.length) nextIdx = 0;
            tabs[nextIdx].focus();
        }

        tabsEl.addEventListener('keydown', function(e) {
            var tab = e.target;
            if (!tab || !tab.classList.contains('cash-pricing__comm-tab'))
                return;

            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                e.preventDefault();
                focusCommodityTab(tab, 1);
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                e.preventDefault();
                focusCommodityTab(tab, -1);
            } else if (e.key === 'Home') {
                e.preventDefault();
                if (tabs.length) tabs[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                if (tabs.length) tabs[tabs.length - 1].focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                tab.click();
            }
        });

        commNames.forEach(function(commName, commIdx) {
            var tab = clonePrototype('commodityTabPrototype', 'button');
            var isActive = commIdx === activeIdx;
            tab.classList.toggle('-active', isActive);
            tab.textContent = commName;
            tab.id = 'cp-comm-tab-' + commIdx;
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.setAttribute('aria-controls', 'cp-comm-panel-' + commIdx);
            tab.setAttribute('tabindex', '0');
            tabs.push(tab);

            var panel = clonePrototype(
                'commodityPanelPrototype',
                '.cash-pricing__comm-panel'
            );
            panel.id = 'cp-comm-panel-' + commIdx;
            panel.setAttribute('aria-labelledby', tab.id);
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            panels[commName] = panel;

            tab.addEventListener('click', function() {
                if (tab.classList.contains('-active')) {
                    tabsEl.classList.toggle('-open');
                    return;
                }
                tabsEl.classList.remove('-open');
                activeCommodity = commName;
                activateCommodityTab(tab, panel);
            });
            tabsEl.appendChild(tab);

            var commData = commMap[commName];

            if (commData.gradeNames.length === 0) {
                var emptyMsg = clonePrototype('commodityEmptyPrototype');
                bindText(emptyMsg, { commodity: commName });
                panel.appendChild(emptyMsg);
            }

            commData.gradeNames.sort(function(a, b) {
                var ra = getGradeRankIndex(commName, a);
                var rb = getGradeRankIndex(commName, b);
                return ra - rb;
            });

            commData.gradeNames.forEach(function(gradeName) {
                var gradeRows = commData.gradeMap[gradeName];
                var gradeBlock = clonePrototype(
                    'commodityGradeBlockPrototype',
                    '.cash-pricing__grade-block'
                );
                var removeBtn = findRegion(gradeBlock, 'removeGradeBtn');
                bindText(gradeBlock, { heading: gradeName });
                bindAriaLabel(removeBtn, gradeName);
                removeBtn.addEventListener(
                    'click',
                    (function(comm, grade) {
                        return function() {
                            excludedGrades.add(comm + '::' + grade);
                            uncheckGradeInMenu(comm, grade);
                            applyFiltersAndRender();
                        };
                    })(commName, gradeName)
                );

                var siteMap = {};
                gradeRows.forEach(function(row) {
                    var site =
                        getVal(row, 'siteDescription', 'siteName') || '—';
                    if (!siteMap[site]) siteMap[site] = [];
                    siteMap[site].push(row);
                });
                var siteNames = Object.keys(siteMap).sort();

                siteNames.forEach(function(site, idx) {
                    var siteRows = sortBuyerRows(siteMap[site]);
                    var bestRow = siteRows[0];
                    var bestPrice = getVal(bestRow, 'price', 'cashPrice');
                    var bestPriceStr =
                        bestPrice !== ''
                            ? '$' + Number(bestPrice).toFixed(2)
                            : '—';

                    var gradeRow = clonePrototype(
                        'gradeRowPrototype',
                        '.cash-pricing__grade-row'
                    );
                    var moreBtn = findRegion(gradeRow, 'moreBtn');
                    var moreBtnText = findRegion(gradeRow, 'moreBtnText');
                    var gradeBadge = findRegion(gradeRow, 'gradeBadge');
                    bindText(gradeRow, {
                        code: site.toUpperCase(),
                        badge: countUniqueValues(
                            siteRows,
                            getBindKeys(gradeBadge, 'data-bind-count')
                        ),
                        price: bestPriceStr,
                    });
                    moreBtn.setAttribute(
                        'aria-controls',
                        'cp-comm-detail-' +
                            commIdx +
                            '-' +
                            gradeName +
                            '-' +
                            idx
                    );
                    var detailPanel = createDetailPanel(siteRows);
                    detailPanel.id =
                        'cp-comm-detail-' +
                        commIdx +
                        '-' +
                        gradeName +
                        '-' +
                        idx;
                    wireMoreDetails(
                        gradeRow,
                        detailPanel,
                        moreBtn,
                        moreBtnText,
                        site + ' ' + gradeName
                    );
                    if (idx === siteNames.length - 1) {
                        gradeRow.classList.add('cash-pricing__grade-row--last');
                    }
                    gradeBlock.appendChild(gradeRow);
                    gradeBlock.appendChild(detailPanel);
                });

                panel.appendChild(gradeBlock);
            });

            panelsEl.appendChild(panel);
        });
    }

    function renderSiteView(rows) {
        if (!siteView) return;
        siteView.replaceChildren();

        var siteNames = [];
        var siteMap = {};
        rows.forEach(function(row) {
            var site = getVal(row, 'siteDescription', 'siteName') || '—';
            var comm = getVal(row, 'commodityDescription', 'commodity') || '—';
            if (!siteMap[site]) {
                siteMap[site] = { commNames: [], commMap: {} };
                siteNames.push(site);
            }
            if (!siteMap[site].commMap[comm]) {
                siteMap[site].commMap[comm] = [];
                siteMap[site].commNames.push(comm);
            }
            siteMap[site].commMap[comm].push(row);
        });

        siteNames.sort(function(a, b) {
            return cmpStr(a, b, 'asc');
        });

        siteNames.forEach(function(siteName) {
            var siteData = siteMap[siteName];

            siteData.commNames.sort(function(a, b) {
                return getCommodityRankIndex(a) - getCommodityRankIndex(b);
            });
            var siteBlock = clonePrototype(
                'siteBlockPrototype',
                '.cash-pricing__site-block'
            );
            var removeBtn = findRegion(siteBlock, 'removeSiteBtn');
            bindText(siteBlock, { heading: siteName });
            bindAriaLabel(removeBtn, siteName);
            removeBtn.addEventListener(
                'click',
                (function(s) {
                    return function() {
                        excludedSites.add(s);
                        applyFiltersAndRender();
                    };
                })(siteName)
            );

            siteData.commNames.forEach(function(commName) {
                var commRows = siteData.commMap[commName];
                var commBlock = clonePrototype(
                    'siteCommodityBlockPrototype',
                    '.cash-pricing__comm-block'
                );
                bindText(commBlock, { heading: commName });

                var gradeNames = [];
                var gradeMap = {};
                commRows.forEach(function(row) {
                    var g =
                        getVal(
                            row,
                            'gradeDescription',
                            'grade',
                            'gradeName',
                            'gradeCode'
                        ) || '—';
                    if (!gradeMap[g]) {
                        gradeMap[g] = [];
                        gradeNames.push(g);
                    }
                    gradeMap[g].push(row);
                });

                gradeNames.sort(function(a, b) {
                    return (
                        getGradeRankIndex(commName, a) -
                        getGradeRankIndex(commName, b)
                    );
                });

                gradeNames.forEach(function(gradeName, gi) {
                    var buyerRows = sortBuyerRows(gradeMap[gradeName]);
                    var firstPrice = getVal(buyerRows[0], 'price', 'cashPrice');
                    var firstPriceStr =
                        firstPrice !== ''
                            ? '$' + Number(firstPrice).toFixed(2)
                            : '\u2014';

                    var gradeRow = clonePrototype(
                        'gradeRowPrototype',
                        '.cash-pricing__grade-row'
                    );
                    var moreBtn = findRegion(gradeRow, 'moreBtn');
                    var moreBtnText = findRegion(gradeRow, 'moreBtnText');
                    bindText(gradeRow, {
                        code: gradeName,
                        badge: buyerRows.length,
                        price: firstPriceStr,
                    });
                    var detailPanel = createDetailPanel(buyerRows);
                    wireMoreDetails(
                        gradeRow,
                        detailPanel,
                        moreBtn,
                        moreBtnText,
                        commName + ' ' + gradeName
                    );
                    if (gi === gradeNames.length - 1) {
                        gradeRow.classList.add('cash-pricing__grade-row--last');
                    }
                    commBlock.appendChild(gradeRow);
                    commBlock.appendChild(detailPanel);
                });

                siteBlock.appendChild(commBlock);
            });

            siteView.appendChild(siteBlock);
        });
    }

    function exportToExcel() {
        var includePool = poolCheck ? poolCheck.checked : true;
        var includeExtended = extendedCheck ? extendedCheck.checked : true;

        var exFilters = getSelectedFilters();

        var rows = allData.filter(function(row) {
            if (!isGrowerCashPricingRow(row)) return false;

            var site = getVal(row, 'siteDescription', 'siteName');
            if (allSitesSet && !allSitesSet.has(site)) return false;
            if (excludedSites.size > 0 && excludedSites.has(site)) return false;

            if (commodityMenuReady) {
                var exCDesc = getVal(row, 'commodityDescription', 'commodity');
                var exGDesc = getVal(
                    row,
                    'gradeDescription',
                    'grade',
                    'gradeName',
                    'gradeCode'
                );
                if (
                    !exFilters.checkedComms.has(exCDesc) &&
                    !exFilters.checkedGrades.has(exCDesc + '::' + exGDesc)
                )
                    return false;
            }
            var payCategory = (
                getVal(row, 'paymentCategory') || ''
            ).toLowerCase();
            if (!includePool && payCategory === 'pool') return false;
            var sOptionType = (
                getVal(row, 'sellingOptionType') || ''
            ).toLowerCase();
            if (
                !includeExtended &&
                payCategory === 'cash' &&
                sOptionType === 'ep'
            )
                return false;
            return true;
        });

        if (groupBy === 'commodity' && excludedGrades.size > 0) {
            rows = rows.filter(function(row) {
                var c =
                    getVal(row, 'commodityDescription', 'commodity') || '—';
                var g =
                    getVal(
                        row,
                        'gradeDescription',
                        'grade',
                        'gradeName',
                        'gradeCode'
                    ) || '—';
                return !excludedGrades.has(c + '::' + g);
            });
        }

        rows.sort(function(a, b) {
            var siteA = getVal(a, 'siteDescription', 'siteName') || '';
            var siteB = getVal(b, 'siteDescription', 'siteName') || '';
            return siteA.localeCompare(siteB);
        });

        var wsData = [
            [
                'Site',
                'Commodity',
                'Grade',
                'Buyer',
                'Price',
                'Price type',
                'Payment terms',
            ],
        ];
        rows.forEach(function(row) {
            var price = getVal(row, 'price', 'cashPrice');
            wsData.push([
                getVal(row, 'siteDescription', 'siteName'),
                getVal(row, 'commodityDescription', 'commodity'),
                getVal(
                    row,
                    'gradeDescription',
                    'grade',
                    'gradeName',
                    'gradeCode'
                ),
                getVal(row, 'ownerDescription', 'buyerName', 'buyer'),
                price !== '' ? Number(price) : '',
                getVal(
                    row,
                    'sellingOptionDescription',
                    'priceType',
                    'purchaseOption'
                ),
                getVal(row, 'paymentTerms', 'paymentTermDescription'),
            ]);
        });

        var ws = XLSX.utils.aoa_to_sheet(wsData);
        ws['!cols'] = [
            { wch: 22 },
            { wch: 18 },
            { wch: 12 },
            { wch: 26 },
            { wch: 12 },
            { wch: 16 },
            { wch: 34 },
        ];
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Cash Pricing');
        var pad = function(n) {
            return String(n).padStart(2, '0');
        };
        var now = new Date();
        var date =
            now.getFullYear() +
            '-' +
            pad(now.getMonth() + 1) +
            '-' +
            pad(now.getDate()) +
            '-' +
            pad(now.getHours()) +
            '-' +
            pad(now.getMinutes());
        var filename = 'Bunge_CashPricing_' + date + '.xlsx';
        var wbOut = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'array',
        });
        var blob = new Blob([wbOut], {
            type: 'application/octet-stream',
        });
        var url = URL.createObjectURL(blob);
        var targetDoc =
            window.top && window.top.document ? window.top.document : document;
        var a = clonePrototype('downloadLinkPrototype');
        a.href = url;
        a.download = filename;
        targetDoc.body.appendChild(a);
        a.click();
        targetDoc.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    if (siteToggle) {
        siteToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            siteDropdownEl.classList.contains('-open')
                ? closeDropdown(siteDropdownEl)
                : openDropdown(siteDropdownEl);
        });
    }

    if (commodityToggle) {
        commodityToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            commodityDropdownEl.classList.contains('-open')
                ? closeDropdown(commodityDropdownEl)
                : openDropdown(commodityDropdownEl);
        });
    }

    var insideDropdownInteraction = false;
    allDropdowns.forEach(function(el) {
        if (!el) return;
        el.addEventListener('mousedown', function() {
            insideDropdownInteraction = true;
        });
        el.addEventListener(
            'touchstart',
            function() {
                insideDropdownInteraction = true;
            },
            { passive: true }
        );
    });
    document.addEventListener('click', function(e) {
        if (insideDropdownInteraction) {
            insideDropdownInteraction = false;
            return;
        }
        if (!root.contains(e.target)) {
            closeAllDropdowns();
            return;
        }
        var inDropdown = allDropdowns.some(function(d) {
            return d && d.contains(e.target);
        });
        if (!inDropdown) closeAllDropdowns();
    });

    if (refreshBtn) refreshBtn.addEventListener('click', fetchPricing);
    if (exportBtn) exportBtn.addEventListener('click', exportToExcel);

    if (groupByToggle) {
        groupByToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            if (groupByToggle.disabled) return;
            groupByDropdownEl.classList.contains('-open')
                ? closeDropdown(groupByDropdownEl)
                : openDropdown(groupByDropdownEl);
        });
    }
    groupByRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
            if (radio.checked) {
                groupByRadios.forEach(function(r) {
                    if (r !== radio) r.checked = false;
                });
                groupBy = radio.getAttribute('data-group-by');
                excludedGrades.clear();
                activeCommodity = null;
                updateGroupByOptionState();
                applyFiltersAndRender();
            }
        });
        if (radio.closest('.cash-pricing__dropdown-item')) {
            radio
                .closest('.cash-pricing__dropdown-item')
                .addEventListener('click', function(e) {
                    e.stopPropagation();
                });
        }
    });

    setupDropdownKeyboard(siteToggle, siteDropdownEl, siteMenuEl, siteSearchEl);
    setupDropdownKeyboard(
        commodityToggle,
        commodityDropdownEl,
        commodityMenuEl,
        null
    );
    setupGroupByKeyboard();

    setupSortHeaders();

    function buildFilterQuery() {
        var parts = [];

        var tickedSites = allSites.filter(function(s) {
            return !excludedSites.has(s.description);
        });
        if (tickedSites.length) {
            if (excludedSites.size === 0) {
                parts.push('sites=ALL');
            } else {
                parts.push(
                    'sites=' +
                        tickedSites
                            .map(function(s) {
                                return s.description;
                            })
                            .join(',')
                );
            }
        }

        var selectedGrades = gradeMenuCheckboxes.filter(function(it) {
            return it.input.checked;
        });
        if (selectedGrades.length) {
            var fullComms = commodityMenuCheckboxes
                .filter(function(it) {
                    return it.input.checked;
                })
                .map(function(it) {
                    return it.commodityDesc;
                });
            if (fullComms.length) {
                parts.push(
                    'commodities=' +
                        fullComms
                            .map(function(d) {
                                return d.toUpperCase();
                            })
                            .join(',')
                );
            }
            var fullCommSet = {};
            fullComms.forEach(function(d) {
                fullCommSet[d] = true;
            });
            var partialGrades = selectedGrades
                .filter(function(it) {
                    return !fullCommSet[it.commodityDesc];
                })
                .map(function(it) {
                    return it.gradeDesc;
                });
            if (partialGrades.length) {
                parts.push('grades=' + partialGrades.join(','));
            }
        }

        parts.push('groupBy=' + groupBy);
        parts.push(
            'poolPrices=' + String(poolCheck ? poolCheck.checked : false)
        );

        return parts.length ? '?' + parts.join('&') : '';
    }

    function updateUrl() {
        if (!urlFiltersApplied) return;
        if (!window.history || !window.history.pushState) return;
        var url =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            buildFilterQuery();
        if (url === window.location.href) return;
        window.history.pushState({ path: url }, '', url);
    }

    function syncSiteMenuFromState() {
        if (!siteMenuEl) return;
        var allCb = siteMenuEl.querySelector('[data-site-all]');
        siteMenuEl.querySelectorAll('[data-site]').forEach(function(cb) {
            var desc = cb.getAttribute('data-site');
            cb.checked = !excludedSites.has(desc);
        });
        if (allCb) allCb.checked = excludedSites.size === 0;
    }

    function applyUrlFilters() {
        var params = new URLSearchParams(initialSearch);

        if (params.has('sites')) {
            var sitesVal = params.get('sites');
            excludedSites.clear();
            if (sitesVal !== 'ALL') {
                var wanted = sitesVal.split(',');
                allSites.forEach(function(s) {
                    if (wanted.indexOf(s.description) === -1) {
                        excludedSites.add(s.description);
                    }
                });
            }
            syncSiteMenuFromState();
        }

        var hasComm = params.has('commodities');
        var hasGrade = params.has('grades');
        if (hasComm || hasGrade) {
            commodityMenuCheckboxes.forEach(function(it) {
                it.input.checked = false;
            });
            gradeMenuCheckboxes.forEach(function(it) {
                it.input.checked = false;
            });
            if (hasComm) {
                var wantedComms = params
                    .get('commodities')
                    .split(',')
                    .map(function(c) {
                        return c.toUpperCase();
                    });
                gradeMenuCheckboxes.forEach(function(it) {
                    if (
                        wantedComms.indexOf(it.commodityDesc.toUpperCase()) !==
                        -1
                    ) {
                        it.input.checked = true;
                    }
                });
            }
            if (hasGrade) {
                var wantedGrades = params.get('grades').split(',');
                gradeMenuCheckboxes.forEach(function(it) {
                    if (wantedGrades.indexOf(it.gradeDesc) !== -1) {
                        it.input.checked = true;
                    }
                });
            }
            commodityMenuCheckboxes.forEach(function(it) {
                syncCommodityStateFromGrades(it.commodityDesc);
            });
            syncAllCommodityState();
        }

        if (params.has('groupBy')) {
            var gb = params.get('groupBy');
            groupBy =
                gb === 'site' || gb === 'commodity' || gb === 'none'
                    ? gb
                    : 'site';
            groupByRadios.forEach(function(r) {
                r.checked = r.getAttribute('data-group-by') === groupBy;
            });
            updateGroupByOptionState();
        }

        if (params.has('poolPrices') && poolCheck) {
            poolCheck.checked = params.get('poolPrices') === 'true';
        }
    }

    function maybeApplyUrlFilters() {
        if (urlFiltersApplied) return;
        if (!sitesMenuReady || !commodityMenuReady) return;
        urlFiltersApplied = true;
        applyUrlFilters();
        applyFiltersAndRender();
    }

    if (poolCheck) poolCheck.checked = false;
    if (extendedCheck) extendedCheck.checked = false;
    if (REGION_NAMES.length) {
        fetchSites();
        fetchCommodities();
        fetchPricing();
    } else {
        showNoRegionsConfigured();
    }
})();
